
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host([bg-color-none]) .wrapper {

    background-color: var(--neutral-white)
}

.wrapper {

    background-color: var(--blue-responsible-lighten-5);

    padding-top: 0.5rem;

    padding-bottom: 0.5rem
}

@media (min-width: 768px) {

    .wrapper {

        padding-top: 4.5rem;

        padding-bottom: 4.5rem
    }
}

.accordion-condensed {

    margin: auto
}

@media (min-width: 1024px) {

    .accordion-condensed {

        width: 60%
    }
}

.header-section {

    text-align: center
}

#eyebrow {

    color: var(--gray-professional-lighten-1)
}

@media (min-width: 768px) {

    .accordion {

        margin-top: 3.5rem
    }
}
`;